//NODE MODULES
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import { useAtomValue } from "jotai";

//KPP COMPONENTS
import LinkImage from "../helpers/LinkImage";

//CONFIG
import { navRoutes } from "../../config/nav";

//ASSETS
import aboutImg from "../../assets/img/hero/about.jpg";
// import aboutImg from "../../assets/img/hero/about.webp";
// import aboutImg from "../../assets/img/logo/kpp-logo-simple.svg";
import contactImg from "../../assets/img/hero/contact.jpg";
// import contactImg from "../../assets/img/hero/contact.webp";
import NewsSlider from "./NewsSlider";

//STATE
import { previewContentAtom } from "../../state/appState";

//GRAPHQL
import { GET_FEATURED_PROJECTS } from "../../graphql/home";

// VARS
let activeIndex = 0;
let activeIndexPrev = activeIndex;
let zIndexCounter = 1;

const Hero = () => {
	const intervalRef = useRef(null);
	const projectTotalIndex = useRef(0);

	//Local State
	const [heroProjects, setHeroProjects] = useState([]);

	//Atom State
	const isPreviewContent = useAtomValue(previewContentAtom);

	//GraphQL Setup
	const [getProjects, { loading: projectsLoading, error: projectsError, data: projectsData }] = useLazyQuery(GET_FEATURED_PROJECTS, {
		variables: {
			isPreview: isPreviewContent,
		},
	});

	useEffect(() => {
		if (projectsError) console.error("ERROR ::", projectsError);
		if (projectsLoading) console.log("LOADING...", projectsLoading);
		if (projectsData) {
			setHeroProjects(projectsData.projectCollection.items);
			projectTotalIndex.current = projectsData.projectCollection.items.length - 1;
		}
	}, [projectsLoading, projectsData, projectsError]);

	useEffect(() => {
		if (heroProjects.length > 0) {
			initRandomImage();
			intervalRef.current = setInterval(showNextImage, 10000);
		}
	}, [heroProjects]);

	useEffect(() => {
		getProjects();

		return () => {
			clearInterval(intervalRef.current);
			intervalRef.current = null;
		};
	}, []);

	const initRandomImage = () => {
		const heroGridSections = Array.from(document.getElementsByClassName("hero-feature-section"));
		activeIndex = generateRandomInt(0, projectTotalIndex.current);

		for (const section of heroGridSections) {
			const heroSectionImgs = section.getElementsByClassName("hero-feature-image");
			const heroSectionInfos = section.getElementsByClassName("hero-feature-info");

			for (const image of heroSectionImgs) {
				const imageIndex = Array.from(heroSectionImgs).indexOf(image);

				if (imageIndex === activeIndex) {
					image.style.zIndex = zIndexCounter;
					image.setAttribute("data-active", "true");

					//If this section contains the info
					if (heroSectionInfos.length > 0) {
						const info = heroSectionInfos[activeIndex];
						info.style.zIndex = zIndexCounter;
						info.setAttribute("data-active", "true");
					}
				}
			}
		}

		activeIndexPrev = activeIndex === 0 ? 0 : activeIndex - 1;
		zIndexCounter++;
	};

	const showNextImage = () => {
		const heroGridSections = Array.from(document.getElementsByClassName("hero-feature-section"));
		shuffleArray(heroGridSections);

		for (const section of heroGridSections) {
			const heroSectionImgs = section.getElementsByClassName("hero-feature-image");
			const heroSectionInfos = section.getElementsByClassName("hero-feature-info");
			const sectionIndex = Array.from(heroGridSections).indexOf(section);

			for (const image of heroSectionImgs) {
				const imageIndex = Array.from(heroSectionImgs).indexOf(image);
				const delay = 300 * (sectionIndex + 1);

				//If this section contains the info
				if (heroSectionInfos.length > 0) {
					const info = heroSectionInfos[activeIndexPrev];
					info.removeAttribute("data-active", "true");
				}

				setTimeout(() => {
					if (imageIndex === activeIndex) {
						image.style.zIndex = zIndexCounter;
						image.setAttribute("data-active", "true");

						//If this section contains the info
						if (heroSectionInfos.length > 0) {
							const info = heroSectionInfos[activeIndex];
							info.style.zIndex = zIndexCounter;
							info.setAttribute("data-active", "true");
						}
					} else if (imageIndex !== activeIndexPrev) {
						image.removeAttribute("data-active", "true");
					}
				}, delay);
			}
		}

		activeIndexPrev = activeIndex;

		if (activeIndex < projectTotalIndex.current) activeIndex++;
		else activeIndex = 0;

		zIndexCounter++;
	};

	const shuffleArray = (array) => {
		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]];
		}
	};

	const generateRandomInt = (min, max) => {
		min = Math.ceil(min);
		max = Math.floor(max);
		return Math.floor(Math.random() * (max - min + 1)) + min;
	};

	return (
		<section id="hero" className="grid-wrapper hero-wrapper">
			<div className="grid-wrapper padding-none hero-feature">
				{[...Array(6)].map((gridElement, idx) => {
					const isBottomLeft = idx === 3;
					return (
						<div key={`hero-feature-${idx}`} aria-hidden="true" className="hero-feature-section">
							{heroProjects.map((project) => {
								return (
									<React.Fragment key={`hero-project-${project.title}-${idx}`}>
										<img src={project.homePageFeatureImage?.url || project.heroImage.url} alt="" className="hero-feature-image" />
										{isBottomLeft && (
											<div className="hero-feature-info">
												<div className="sectors">
													{project.sectorCollection.items.map((sector) => (
														<span key={`hero-projectSector-${project.title}-${idx}-${sector}`}>{sector.name}</span>
													))}
												</div>
												<Link to={`/projects/project/${project.slug}`}>{project.title}</Link>
												<Link to={`/projects/project/${project.slug}`}>
													View Project Details <i className="bi bi-arrow-right" />
												</Link>
											</div>
										)}
									</React.Fragment>
								);
							})}
						</div>
					);
				})}
			</div>
			<div className="backgroundColor-kppCream hero-news">
				<NewsSlider />
			</div>
			<div className="backgroundColor-kppCream hero-about">
				<LinkImage slug={navRoutes.about} title="About" image={aboutImg} />
			</div>
			<div className="backgroundColor-kppCream hero-contact">
				<LinkImage slug={navRoutes.contact} title="Contact" image={contactImg} />
			</div>
		</section>
	);
};

export default Hero;
